<template>
  <c-popup v-show="visible">
    <div class="plv-ia-confirm__header">
      <span>{{ t('plvIA.common.tips') }}</span>
      <i @click="handleCancel">&times;</i>
    </div>
    <p class="plv-ia-confirm__body">{{ tips }}</p>
    <div class="plv-ia-confirm__footer">
      <button :class="ensureBtnCls" @click="handleEnsure">{{ ensureTxt }}</button>
      <button class="plv-ia-btn-new plv-ia-btn-cancel pws-vclass-btn-cancel" @click="handleCancel">{{ cancelTxt }}</button>
    </div>
  </c-popup>
</template>

<script>
import Locale from '@/mixins/locale';
import Popup from './Popup';

export default {
  name: 'CommonConfirm',
  components: {
    'c-popup': Popup
  },
  mixins: [Locale],

  props: {
    tips: {
      type: String,
      default: '',
    },
    ensureTxt: {
      type: String,
      default: '',
    },
    cancelTxt: {
      type: String,
      default: ''
    },
    ensureBtnCls: {
      type: String,
      default: 'plv-ia-btn-new plv-ia-btn-blue pws-vclass-btn-blue',
    }
  },

  data() {
    return {
      visible: false,
    };
  },

  methods: {
    handleEnsure() {
      this.$emit('ensure');
    },

    handleCancel() {
      this.$emit('cancel');
    },

    show() {
      this.visible = true;
    },

    hide() {
      this.visible = false;
    }
  },
};
</script>

<style lang="scss">
.plv-ia-confirm__header {
  border-bottom: 1px solid rgba(#000, 0.1);
  line-height: 48px;
  padding: 0 20px 0 16px;

  span {
    color: #333;
    font-size: 14px;
  }

  i {
    color: #90A4AE;
    float: right;
    font-style: normal;
    font-size: 20px;
    user-select: none;
    cursor: pointer;
  }
}

.plv-ia-confirm__body {
  font-size: 14px;
  color: #333;
  margin-top: 38px;
  margin-bottom: 38px;
  text-align: center;
}

.plv-ia-confirm__footer {
  text-align: center;
  margin-top: 15px;

  button {
    margin: 0 6px;
  }
}
</style>
